import { useState } from "react";
import {
  Box,
  Flex,
  IconButton,
  Popover,
  PopoverArrow,
  PopoverBody,
  PopoverContent,
  PopoverTrigger,
  Text,
} from "@chakra-ui/react";
import { Info } from "@phosphor-icons/react";
import { useTranslation } from "react-i18next";
import { PURCHASED_CATEGORIES } from "./const";

/**
 * Info popover surfaced next to the purchased-electricity add-modal heading.
 * Shows the verbatim description for each category, pulled from i18n
 * (`categories.{code}` for the label, `categories.{code}_DESC` for the body).
 *
 * The popover is manually controlled so opening the modal — which auto-focuses
 * the first focusable child — doesn't pop the definitions open. Only real
 * mouse-hover or click should trigger it.
 */
function CategoryInfoPopover() {
  const { t } = useTranslation("translation", {
    keyPrefix: "organizationQuestionnaire.scope2V2",
  });
  const [isOpen, setIsOpen] = useState(false);

  return (
    <Popover
      isOpen={isOpen}
      onClose={() => setIsOpen(false)}
      placement="bottom-start"
      gutter={4}
      closeOnBlur
    >
      <PopoverTrigger>
        <IconButton
          aria-label="Category definitions"
          icon={<Info size={16} weight="bold" />}
          size="sm"
          variant="ghost"
          color="gray.500"
          _hover={{ color: "limeShade.600", bg: "lightLime" }}
          onMouseEnter={() => setIsOpen(true)}
          onMouseLeave={() => setIsOpen(false)}
          onClick={() => setIsOpen((v) => !v)}
        />
      </PopoverTrigger>
      <PopoverContent
        maxW="520px"
        boxShadow="lg"
        borderRadius="md"
        border="1px solid"
        borderColor="gray.200"
        onMouseEnter={() => setIsOpen(true)}
        onMouseLeave={() => setIsOpen(false)}
      >
        <PopoverArrow />
        <PopoverBody p={4}>
          <Flex direction="column" gap={3}>
            {PURCHASED_CATEGORIES.map((code) => (
              <Box key={code}>
                <Text fontSize="14px" fontWeight="700" color="darkTeal" mb={1}>
                  {t(`categories.${code}`)}
                </Text>
                <Text fontSize="13px" color="gray.600" lineHeight="1.5">
                  {t(`categories.${code}_DESC`)}
                </Text>
              </Box>
            ))}
          </Flex>
        </PopoverBody>
      </PopoverContent>
    </Popover>
  );
}

export default CategoryInfoPopover;
